import React from "react"
import PropTypes from "prop-types"
import ReactSelect from "react-select"
import { omit } from "utils"
import { CrossIcon } from "components"
import styled, { injectGlobal } from "styled-components"
import COLOR_PALETTE from "constants/color-palette"
import globalStyles from "react-select/dist/react-select.css"

if (process.env.BABEL_ENV && process.env.BABEL_ENV === "dingo") {
  injectGlobal`
    ${globalStyles}
  `
} else {
  require("react-select/dist/react-select.css")
}


const SelectStyle = styled.div`
    box-sizing: border-box;
    text-align: left;
    max-width: 100%;

    & * {
      box-sizing: border-box;
    }

    & *:focus,
    & *:focus *,
    & .is-focused,
    & .is-focused * {
      outline: none !important;
      box-shadow: none !important;
    }

    & .Select {
      position: relative;
      font-weight: 200;
    }

    .Select-control {
      display: flex;
      align-items: center;
      background-color: transparent;
      border: none;
      border-bottom: 1px solid #d5d5d5;
      border-radius: 0;
      text-align: left;
    }

    & .Select-multi-value-wrapper {
      margin-bottom: -.3em;
    }

    & .Select-multi-value-wrapper {
      flex: 1 1 100%;
      position: relative;
    }

    & .Select-clear-zone {
      flex: 0 0 auto;
      width: initial;
    }

    & .Select-arrow-zone {
      width: initial;
    }

    & .Select.is-disabled .Select-control {
      background-color: transparent;
    }

    & .Select-input {
      width: 100%;
      display: flex !important;
      align-items: center;
    }
    & .Select-input > input {
      min-width: 100%;
      padding: 0;
      vertical-align: 'baseline';
    }

    & .Select-input,
    & .Select--single > .Select-control .Select-value,
    & .Select-placeholder {
      padding: 0;
      color: inherit;
    }

    & .is-open > .Select-control {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      background: transparent;
      border-color: transparent transparent #ddd;
    }

    & .is-focused:not(.is-open) > .Select-control {
      border-color: #ddd;
      background-color: inherit;
    }

    & .Select-menu-outer {
      text-align: left;
      border-radius: 0;
      background-color: #fff;
      border: 1px solid #ddd;
      box-shadow: 2px 2px 10px rgba(0, 0, 0, .125) !important;
      width: calc(100% + 2em);
      margin: -2px 0 0 -1em;
    }

    & .Select-option,
    & .Select-noresults {
      background-color: #fff;
      color: #666666;
      cursor: default;
      display: block;
      padding: 1em;
    }

    & .Select-option:last-child {
      border-radius: 0;
    }

    & .Select-option.is-selected {
      background-color: #e3e3e3;
      color: #333;
    }

    & .Select-option.is-focused {
      background-color: #c1d3e2;
      color: #333;
    }

    & .Select-option.is-disabled {
      color: #cccccc;
      cursor: default;
    }
`


const themeLight = {
  text: () => ({
    color: COLOR_PALETTE.BLACK
  })
}

const themeDark = {
  text: () => ({
    color: COLOR_PALETTE.WHITE
  })
}

const themes = {
  dark: themeDark,
  light: themeLight
}

const Chevron = ({ style }) => (
  <svg style={style} viewBox="0 0 20 20">
    <path d="M0 5.8l1.6-1.6 8.4 8.4 8.4-8.4L20 5.8l-10 10-10-10z" />
  </svg>
)

const renderControl = Svg => () => (
  <div style={{ width: "0.85em", height: "0.85em", marginLeft: "auto" }}>
    <Svg style={{ fill: "#aaa", width: "100%", height: "100%" }} />
  </div>
)

const SelectBase = (props) => {
  const selectProps = {
    arrowRenderer: renderControl(Chevron),
    clearRenderer: renderControl(CrossIcon),
    ...omit(["style", "className"], props),
    autoFocus: false,
    style: {
      color: props.styleName ? themes[props.styleName].text().color : "#aaa"
    }
  }
  return (
    <SelectStyle
      style={{ ...props.style }}
      ref={props.getRef}>
      <ReactSelect {...selectProps} />
    </SelectStyle>
  )
}

SelectBase.propTypes = {
  arrowRenderer: PropTypes.func,
  clearRenderer: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object
}

SelectBase.defaultProps = {
  style: {}
}

export default SelectBase



// WEBPACK FOOTER //
// ./src/components/form-elements/select-base/dingo.jsx